module.exports = __webpack_public_path__ + "img/Pic_PT_Tc_UpD_c.0d119aa8.png";